import parse from 'html-react-parser';
import { useState } from 'react';
import ModalInstruction from './ModalInstruction';
import { getText } from '../utils/languageUtils';

const SingleSelectPdfImage = ({ language, question, setSelectedOptions, selectedOptions, answer, isMarked }) => {
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const handleOptionChange = (id, title) => {
     
        setSelectedOptions({
            id: id,
            title: title
        });
    };

    return (
        <>
            <div className='justify-content-end d-flex' >
                <div onClick={handleShow}>
                    <img src={require("../assets/images/instructions.png")} className='mobielViewIcon' alt="instructions"/>
                </div>
            </div>
            <div className="row">
                <div className="col-12">
                    <div className="sectionsBox">
                        <p className="mb-0 text-center">{getText(question.title, language)}</p>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-12 ">
                    {getText(question.description, language).length > 0 && <div className="contentbox mb-2 mt-3">
                        <div className="content_safty ">
                            {parse(getText(question.description, language))}
                        </div>
                    </div>
                    }
                </div>
            </div>
            <form action="">
                <div className="row">
                    <div className="col-12 mb-3">

                        {question.question_option.map((item, index) => (

                            <div className="vedioSelectBox my-4" key={index}>
                                <div
                                    className={`image-radio-button`}
                                    onClick={() => { handleOptionChange(item.id, getText(item.title, language)) }}
                                >
                                    <div className={`optionsTop text-center
                                     ${(isMarked === 0 && selectedOptions?.id === item.id) ? 'selectedButton' : ''}
                                     ${(isMarked === 1 && (item.id === Number(answer?.course_module_item?.[0]?.option_marked?.id))) ? 'markedChoice' : ''}
                                     `}>
                                        <p className={`mb-0`}>Option {index + 1}</p>
                                        <img src={getText(item.file_path, language)} width={"100%"} style={{ margin: 0, backgroundColor: "#fff" }} />
                                    </div>
                                </div>
                            </div>
                        ))}

                    </div>
                </div>
            </form>
            <ModalInstruction show={show} handleClose={handleClose} inst={parse(getText(question.instruction, language))} />
        </>
    )
}

export default SingleSelectPdfImage